const pageNameKey = "otaBackupProcessReviewRequestAndApprove";

export const otaBackupProcessReviewRequestAndApproveEn = {
  [pageNameKey]: {
    title: "Backup Process Request for Approval",
    descriptionTemplate:
      "The Technician {initiator} requests to create a backup of this machine.",
    reviewAndApproveButtonText: "Review Request and Approve",
  },
};

export const otaBackupProcessReviewRequestAndApprovePtBr = {
  [pageNameKey]: {
    title: "Solicitacao de aprovacao do processo de backup",
    descriptionTemplate:
      "O Tecnico {initiator} solicita criar um backup desta maquina.",
    reviewAndApproveButtonText: "Revisar solicitacao e aprovar",
  },
};

export const otaBackupProcessReviewRequestAndApproveDe = {
  [pageNameKey]: {
    title: "Backup-Prozessanfrage zur Genehmigung",
    descriptionTemplate:
      "Der Techniker {initiator} fordert an, ein Backup dieser Maschine zu erstellen.",
    reviewAndApproveButtonText: "Anfrage pruefen und genehmigen",
  },
};

export const otaBackupProcessReviewRequestAndApproveZhHans = {
  [pageNameKey]: {
    title: "备份流程审批请求",
    descriptionTemplate: "技术人员 {initiator} 请求为此设备创建备份。",
    reviewAndApproveButtonText: "审核请求并批准",
  },
};

export const otaBackupProcessReviewRequestAndApproveIt = {
  [pageNameKey]: {
    title: "Richiesta di approvazione del processo di backup",
    descriptionTemplate:
      "Il Tecnico {initiator} richiede di creare un backup di questa macchina.",
    reviewAndApproveButtonText: "Rivedi richiesta e approva",
  },
};

export const otaBackupProcessReviewRequestAndApproveEs = {
  [pageNameKey]: {
    title: "Solicitud de aprobacion del proceso de respaldo",
    descriptionTemplate:
      "El Tecnico {initiator} solicita crear un respaldo de esta maquina.",
    reviewAndApproveButtonText: "Revisar solicitud y aprobar",
  },
};

export const otaBackupProcessReviewRequestAndApproveNl = {
  [pageNameKey]: {
    title: "Back-upproces: aanvraag voor goedkeuring",
    descriptionTemplate:
      "De technicus {initiator} vraagt om een back-up van deze machine te maken.",
    reviewAndApproveButtonText: "Verzoek beoordelen en goedkeuren",
  },
};

export const otaBackupProcessReviewRequestAndApproveTr = {
  [pageNameKey]: {
    title: "Yedekleme İşlemi Onay Talebi",
    descriptionTemplate:
      "Teknisyen {initiator} bu makinenin bir yedeğini oluşturmayı talep ediyor.",
    reviewAndApproveButtonText: "İsteği İncele ve Onayla",
  },
};
